import { DatePipe } from "@angular/common";
import { ChangeDetectorRef, Component, EventEmitter, inject, Input, OnChanges, Output, ViewChild } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { interval, tap } from "rxjs";
import { MagicBellService } from "../services";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { Cls_MBNotificationMain, Cls_MagiBellCategory, Cls_MBNotification } from "../models";
import { UnSubscriber } from "../UnSubscriber";

@Component({
  selector: "mobi-office-lib-notification",
  templateUrl: "./notification.component.html",
  styleUrls: ["./notification.component.scss"],
  standalone: false,
})
export class NotificationComponent extends UnSubscriber implements OnChanges {
  private readonly datePipe = inject(DatePipe);
  private readonly toastr = inject(ToastrService);
  private readonly magicBellService = inject(MagicBellService);
  private readonly router = inject(Router);
  private readonly cdRef = inject(ChangeDetectorRef);

  constructor() {
    super();
  }

  ngOnChanges(): void {
    // Loading Spinner
    this.anotherSubscription = this.magicBellService.getSpinnerObserver().subscribe(status => {
      this.showSpinner = status === "start";
      this.cdRef.detectChanges();
    });

    if (this.externalUserID) {
      this.getMagicBallNotification();
      this.getAllNotifications();
    }
  }

  notification: Cls_MBNotificationMain = new Cls_MBNotificationMain();
  @Input({ required: true }) externalUserID: string = "";
  @Input() notificationCategory: Cls_MagiBellCategory[] = [
    {
      name: "All",
      value: "all",
    },
    {
      name: "General",
      value: "general",
    },
  ];
  @Input() notificationItemsPerPage: number = 10;
  @Input() notificationPageNo: number = 1;

  selectedCategory: string = "all";
  showSpinner: boolean = false;
  @ViewChild("notificationPopoverElement") notificationPopoverElement!: NgbPopover;

  @Output() notificationChange = new EventEmitter();

  getSentTime(sent_at: number): string {
    const formattedDate = this.datePipe.transform(new Date((sent_at || 1) * 1000), "dd-MM-yyyy h:mm a");
    return formattedDate || "";
  }

  //#region Notifications
  getMagicBallNotification() {
    const category = this.selectedCategory === "all" ? "" : this.selectedCategory;
    this.magicBellService.getNotification(this.externalUserID, 10, this.notificationPageNo, [category]).subscribe((res: any) => {
      this.notification = res;
    });
  }

  private getAllNotifications() {
    const callInterval = interval(1000 * 60);
    callInterval
      .pipe(
        tap(() => {
          this.getMagicBallNotification();
        })
      )
      .subscribe();
  }

  onShowNotification() {
    this.magicBellService.markAllNotificationsAsSeen(this.externalUserID).subscribe(() => {
      this.getMagicBallNotification();
    });
  }

  onHideNotification() {
    this.notificationPageNo = 1;
    this.selectedCategory = "all";
    this.getMagicBallNotification();
  }

  onClickNotification(item: Cls_MBNotification) {
    if (this.showSpinner) return;
    if (!item.read_at)
      this.magicBellService.markNotificationAsRead(item.id || 0).subscribe(() => {
        this.getMagicBallNotification();
      });
    if (item.action_url) {
      this.notificationPopoverElement?.close();
      this.router.navigate([item.action_url]);
    }
  }

  onNotificationOption(event: Event) {
    event?.stopPropagation();
  }

  onMarkAllAsRead() {
    this.magicBellService.markAllNotificationsAsRead(this.externalUserID).subscribe(() => {
      this.getMagicBallNotification();
    });
  }

  notificationMarkAsReadAndUnRead(item: Cls_MBNotification, event: Event) {
    if (item.read_at) {
      this.magicBellService.markNotificationAsUnRead(item.id || 0).subscribe(() => {
        this.getMagicBallNotification();
      });
    } else {
      this.magicBellService.markNotificationAsRead(item.id || 0).subscribe(() => {
        this.getMagicBallNotification();
      });
    }
    event?.stopPropagation();
  }

  deleteNotification(item: Cls_MBNotification, event: Event) {
    this.magicBellService.deleteNotification(item.id || 0).subscribe(() => {
      this.getMagicBallNotification();
    });
    event?.stopPropagation();
  }

  onArrowLeft() {
    if (this.notificationPageNo === 1) return;
    this.notificationPageNo = this.notificationPageNo - 1;
    this.getMagicBallNotification();
  }

  onArrowRight() {
    if (this.notification.notifications.length < this.notificationItemsPerPage) {
      this.toastr.info("Notification Not Found", "Info");
      return;
    }
    this.notificationPageNo = this.notificationPageNo + 1;
    this.getMagicBallNotification();
  }
  //#endregion
}
